<template>
  <div
    class="finance-deposit-cell"
    :class="{
      'finance-deposit-cell-red': cellValue <= 0 || cellValue > depositAmountMax,
      'finance-deposit-cell-yellow': cellValue > 0 && cellValue < depositAmountMax,
      'finance-deposit-cell-green': cellValue === depositAmountMax,
    }"
  >
    {{ formatAmount(cellValue) }}
  </div>
</template>

<script>
export default {
  name: "finance-deposit-cell",
  props: ["cellValue", "depositAmountMax"],
  methods: {
    formatAmount(x) {
      if (!x) {
        return "";
      }
      if (x > 0) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      if (x < 0) {
        return `- ${(-1 * x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.finance-deposit-cell {
  height: 100%;
  line-height: 13px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 13px;
  padding: 10px !important;
  -webkit-transition: font 0.3s ease;
  transition: font 0.3s ease;

  &-green {
    background: #d0f4e3;
  }

  &-red {
    background: #ffe6f2;
  }

  &-yellow {
    background: #fdffb3;
  }
}
</style>
